(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('EditIndividualAccount', [
			'$filter',
			'globalConfig',
			'US_STATES',
			EditIndividualAccountFunction
		]);

	function EditIndividualAccountFunction(
		$filter,
		globalConfig,
		US_STATES
	) {
		var editIndividualAccount = this;

		editIndividualAccount.states = US_STATES;

		angular.merge(editIndividualAccount, globalConfig);

		editIndividualAccount.serializedForm.state = $filter('findSelectedOption')(editIndividualAccount.serializedForm.state, 'abbreviation', editIndividualAccount.states);
	}
})(window.angular);